import { isBranch } from '@basehub/data/replicache/index'
import { useSelectedBranchOrCommitQuery } from '~/lib/commits/use-selected-branch-or-commit'
import { getOriginUrl } from '@basehub/data/replicache/mutators/repo-space/commit/url-utils'
import { useSelectedTeamAndRepo } from '../use-selected-team-and-repo'

export const useOriginUrl = () => {
  const { data: branchOrCommit } = useSelectedBranchOrCommitQuery()
  const { data: selectedTeamAndRepo } = useSelectedTeamAndRepo()

  return getOriginUrl({
    repo: selectedTeamAndRepo?.repo ?? null,
    branch: branchOrCommit && isBranch(branchOrCommit) ? branchOrCommit : null,
  })
}
